export const state = {
    isVisible: false,
    products: [],
    currentIndex: 0,
    readOnly: false,
    searchString: ''
}

export const mutations = {
    show(state, { products, currentIndex = 0, readOnly = false, searchString = '' }) {
        state.products = products;
        state.currentIndex = currentIndex;
        state.readOnly = readOnly;
        state.searchString = searchString;
        state.isVisible = true;
    },
    hide(state) {
        state.isVisible = false;
    },
    setCurrentIndex(state, index) {
        state.currentIndex = index;
    },
    nextProduct(state) {
        if (state.currentIndex < state.products.length - 1) {
            state.currentIndex++;
        }
    },
    previousProduct(state) {
        if (state.currentIndex > 0) {
            state.currentIndex--;
        }
    }
}

export const getters = {
    currentProduct: (state) => {
        return state.products[state.currentIndex] || null;
    },
    isFirstProduct: (state) => {
        return state.currentIndex === 0;
    },
    isLastProduct: (state) => {
        return state.currentIndex === state.products.length - 1;
    },
    productCount: (state) => {
        return state.products.length;
    }
}
